import axios from "axios";

const http = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

const getAppInfo = async () => {
  return (await http.get(`/version`)).data;
};

export default {
  getAppInfo
};
